<template>
    <div class="admin-layout">
      <!-- 左侧导航栏 -->
      <aside class="sidebar">
        <!-- logo + 菜单 -->
        <div class="sidebar-logo">
          <img class="sidebar-logo-img" src="@/assets/images/白字.png" alt="logo" />
          <!-- <div class="sidebar-logo-info">
            <div class="sidebar-title">声瀚网络科技</div>
            <div class="sidebar-subtitle">SHENGHAN NETWORK TECHNOLOGY</div>
          </div> -->
        </div>
        <el-menu :default-active="$route.path" class="sidebar-menu" background-color="#222" text-color="#fff" active-text-color="#3BB2FF" router  >
          <el-menu-item index="/"><i class="el-icon-s-home"></i> 首页</el-menu-item>
          <el-menu-item index="/room"><i class="el-icon-document"></i> 群组管理</el-menu-item>
          <el-menu-item index="/card"><i class="el-icon-data-analysis"></i> 数据查询</el-menu-item>
        </el-menu>
      </aside>
      <!-- 主体内容 -->
      <div class="main-content">
        <!-- 头部 -->
        <header class="header-bar">
          <div class="header-left" style="    display: flex;justify-content: center;align-items: center;margin-left: 20px;">
          
            <div style=" display: flex;justify-content: center;align-items: center;">
              <el-avatar :size="36" src="https://user-avatar-url.com/avatar.jpg"></el-avatar>
              <span class="header-username">{{ userInfo.nick_name }}</span>
            </div>
            <div style="margin-left:30px;">
              <span>代理类型【{{formatType(userInfo.type)}}】</span>
            </div>
            <div style="margin-left:30px;">
              <span>到期时间【{{userInfo.expire_time}}】</span>
            </div>
            <div style="margin-left:30px;">
              <span>账户余额【{{userInfo.recharge_amount}}】</span>
            </div>
          </div>
          <div class="header-right">
            
            <i class="el-icon-more" @click="dialogVisible = true" style="cursor: pointer;"></i>
            <i class="el-icon-refresh" style="margin-left:24px;" @click="handleRefresh"></i>
          </div>
        </header>
        <!-- 页面内容区 -->
        <div class="content-area">
          <router-view :key="refreshKey"  @refreshUserInfo="refreshUserInfo"/>
        </div>
      </div>
      <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="400px"
      @close="resetForm"
    >
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="form.oldPassword" type="password" show-password />
        </el-form-item>

        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="form.newPassword" type="password" show-password />
        </el-form-item>

        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="form.confirmPassword" type="password" show-password />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    </div>
  </template>
  
  <script>
  export default {
    name: "LayoutPage",
    data() {
      return {
        refreshKey: 0, // 初始化 key
        userInfo:{},
        types: [
        {
          name:'储值代理',
          val:1
        },{
          name:'月结代理',
          val:2
        }],
        form:{},
        dialogVisible:false
      }
    },
    methods: {
      formatType(val) {
        const found = this.types.find(item => item.val === val);
        console.log(found)
        return found ? found.name : val;
      },
      handleRefresh() {
        this.refreshKey += 1; // key 改变 => router-view 重新挂载
      },
      refreshUserInfo() {
        console.log('刷新了 userInfo', this.userInfo)

        const userInfo = localStorage.getItem('userInfo');
        this.userInfo = JSON.parse(userInfo);
      },
      resetForm(){
        this.dialogVisible = true;
      },
      async submitForm(){
        const res = await this.$axios.post('/auth/updatePassword', this.form)
          if(res.code == 200){
            localStorage.setItem('token','')
            localStorage.setItem('userInfo','')
            this.$router.push("/login")
          }
      }
    },
    created(){
      var userInfo = localStorage.getItem('userInfo')
      this.userInfo = JSON.parse(userInfo)
      console.log('用户信息',this.userInfo)
    }
  }
  </script>
  

  <style scoped>
  .admin-layout {
    display: flex;
    width: 100vw;
    height: 100vh;
    background: #fff;
  }
  
  .sidebar {
    width: 220px;
    background: #222;
    color: #fff;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
  
  .sidebar-logo {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 22px 16px 18px 16px;
  }
  
  .sidebar-logo-img {
    width: 200px;
    height: 38px;
    margin-right: 8px;
    object-fit: contain;
  }
  
  .sidebar-logo-info {
    display: flex;
    flex-direction: column;
  }
  
  .sidebar-title {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;
  }
  
  .sidebar-subtitle {
    font-size: 10px;
    letter-spacing: 1px;
    margin-top: 2px;
  }
  
  .sidebar-menu {
    border: none;
    background: #222;
    margin-top: 16px;
  }
  
  .main-content {
    flex: 1;
    /* display: flex; */
    flex-direction: column;
    background: #fff;
  }
  
  .header-bar {
    height: 60px;
    background: #888;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 36px 0 0;
  }
  
  .header-right {
    display: flex;
    align-items: center;
  }
  
  .header-username {
    margin-left: 10px;
    font-size: 16px;
    color: #fff;
    font-weight: 500;
  }
  
  .content-area {
    padding: 18px 0 10px 18px;
    width: 98%;
  }
  
  .content-title {
    font-size: 16px;
    color: #222;
    margin-bottom: 28px;
    font-weight: 500;
  }
  
  .card-list {
    display: flex;
    flex-direction: row;
    gap: 32px;
  }
  
  .renew-card {
    background: #f7f7f7;
    border-radius: 20px;
    box-shadow: 0 2px 8px #eee;
    width: 200px;
    height: 260px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 18px 0 0 0;
  }
  
  .renew-card-img {
    width: 110px;
    height: 150px;
    border-radius: 14px;
    object-fit: cover;
    margin-bottom: 16px;
  }
  
  .renew-card-info {
    width: 170px;
    text-align: center;
  }
  
  .renew-card-title {
    font-size: 14px;
    font-weight: 500;
    color: #222;
    margin-bottom: 6px;
  }
  
  .renew-card-desc {
    font-size: 13px;
    color: #7a7a7a;
  }

  html, body, #app {
    height: 100%;
    margin: 0;
    }
  </style>